import { getRuntimeVar } from "../../constants/envUtilities";

const apiUrl = external => {
  const whichApi = external ? 'external' : 'admin';
  const path = `/static/swagger/${whichApi}/swagger.yaml`;

  // 1. Try Runtime (Docker) -> Then Webpack Macro (Local .env)
  let endpoint = getRuntimeVar('ENDPOINT', typeof __ENDPOINT__ !== 'undefined' ? __ENDPOINT__ : '');

  // 2. The "Legacy Magic" Fallback
  // ONLY run this if 'endpoint' is still empty.
  // This preserves the old behavior for local devs who didn't set an ENDPOINT var.
  if (!endpoint) {
    const isEu = (typeof __STAGINGEU__ !== 'undefined' && __STAGINGEU__) ||
      (typeof __PRODEU__ !== 'undefined' && __PRODEU__);
    const region = isEu ? 'eu' : 'us';

    const useStaging = (typeof __LOCAL__ !== 'undefined' && __LOCAL__) ||
      (typeof __DEV__ !== 'undefined' && __DEV__) ||
      (typeof __STAGING__ !== 'undefined' && __STAGING__) ||
      (typeof __STAGINGEU__ !== 'undefined' && __STAGINGEU__);

    const environment = useStaging ? 'staging' : 'production';

    // This was the logic forcing you to Prod.
    // It will only happen now if you FORGOT to pass -e ENDPOINT in Docker.
    endpoint = `https://${region}-kardia-${environment}.alivecor.com`;
  }

  // Remove trailing slashes
  if (endpoint.endsWith('/')) {
    endpoint = endpoint.slice(0, -1);
  }

  return `${endpoint}${path}`;
}

export default apiUrl;



// WEBPACK FOOTER //
// ./src/components/Swagger/apiUrl.js